<template>
  <b-card>
    <div slot="header">
      <h4 class="mr-5 pull-left">NVI</h4>
      <new-button button_type="new" variant="primary" class="pull-right"  @click="aside = true">
        Dodaj NVI
      </new-button>
    </div>
    <app-aside  v-model="aside">
      <template slot="header">Dodaj NVI</template>
      <br/>
      <nvi-form  @success="closeAndReload"></nvi-form>
    </app-aside>
    <app-aside  v-model="editAside">
      <template slot="header">Uredi NVI</template>
      <br/>
      <nvi-form :nvi-object="nviEdit"  @success="closeAndReload"></nvi-form>
    </app-aside>
    <div class="position-relative">
      <div class="table-container">
        <b-table class="applicant_table animated fadeIn"   :tbody-tr-class="rowClass"  responsive hover  :fields="fields" :items="items" primary-key="id" :busy="loading">
          <template v-slot:cell(date) = "data">
            {{data.item.date | formatDate}}
          </template>
          <template v-slot:cell(value) = "data">
            {{data.item.value | formatDecimals(4)}}
          </template>
          <template v-slot:cell(edit)="data">
            <app-button class="pull-right"
                        @click="edit(data.item)"
                        size="sm"
                        variant="link">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </app-button>
          </template>

        </b-table>
        <b-pagination
          size="sm"
          :prev-text="$t('PREV')"
          :next-text="$t('NEXT')"
          :total-rows="total"
          :per-page="perPage"
          v-model="currentPage">
        </b-pagination>

      </div>
    </div>
  </b-card>
</template>

<script>
import AppAside from '@/components/app/form/AppAside'
import NewButton from '@/components/app/AppButton'
import AppButton from "@/components/app/AppButton";
import {getNviList} from "@/services/nvi";
import {formatDate, formatDecimals} from '@/filters/formatDates';
import NviForm from "@/components/nvi/NviForm";
export default {
  name: 'Index',
  data() {
    return {
      fields: [
        {key: 'date', label: 'Datum'},
        {key: 'value', label: 'Vrijednost'},
        {key: 'edit', label: ''},
      ],
      editAside: false,
      nviEdit: null,
      items: [],
      loading: false,
      total: 0,
      perPage: 20,
      currentPage: 1,
      aside: false
    }
  },
  filters:{
    formatDate,
    formatDecimals
  },
  components: {
    NviForm,
    AppButton,
    NewButton,
    AppAside
  },
  methods: {
    edit(nviObject) {
      this.nviEdit = nviObject;
      this.editAside = true;
    },
    search() {
      this.loading = true;
      const request = {...this.filter, ...{ limit: 20, page: this.currentPage }}
      getNviList(request).then((response) => {
        this.items = response.data.items
        this.total = response.data.total
        this.currentPage = response.data.page
      }).finally(() => {
        this.loading = false
      })
    },
    closeAndReload() {
      this.aside = false;
      this.nviEdit = null;
      this.editAside = false;
      this.search();
    },
    rowClass(item) {
      if(item.active) {
        return 'alert-success'
      }
      return  ''
    }
  },
  async mounted(){
    await this.search();
  },
  watch: {
    currentPage: {
      handler() {
        this.search();
      }
    }
  }
};
</script>

<style>
</style>
